// extracted by mini-css-extract-plugin
export default {"spacingTypeOfList":"SummaryStep_spacingTypeOfList__CzFrQ","color-text-subtitle":"SummaryStep_color-text-subtitle__id+jL"};